import { render } from "./projectCard.vue?vue&type=template&id=40403ad2&scoped=true"
import script from "./projectCard.vue?vue&type=script&lang=js"
export * from "./projectCard.vue?vue&type=script&lang=js"

import "./projectCard.vue?vue&type=style&index=0&id=40403ad2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40403ad2"]])

export default __exports__